import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

@Entity()
export class ContractFile extends AdornisFile {
  public static override _class = 'ContractDocument';

  @validate(nonOptional())
  @Field(() => ID)
  contractID!: string;
}
